import envVariables from '../envVariables';
import languageCodes from './languageCodes';
import marketCodes from './marketCodes';

const fallbackLocalizationCodes = {
    languageCode: languageCodes.EN,
    marketCode: envVariables.MARKET_CODE ?? marketCodes.PMI,
};

export default fallbackLocalizationCodes;
